import { Injectable } from '@angular/core';
import { INDRAApiService } from '@ibe.services/api.indra.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MOCK_STATUS, MOCK_URL_AVAILABLE_PASSENGER_TYPE, URL_AVAILABLE_PASSENGER_TYPES, MOCK_URL_AVAILABLE_PASSENGER_TYPE_UK_MARKET, PAX_TYPE_YOUNG_ADULT, PAX_TYPE_YOUNG_ADULT_CODE, PAX_TYPE_ADULT_CODE } from '@ibe.config';
import { INDRABFMAvailablePassengerTypeResponse, INDRABFMAvailablePassengerTypeRequestParam, INDRAPaxTypeBusinessRules } from '@ibe.models/passenger.model.indra.lib';

@Injectable({
	providedIn: 'root'
})
export class INDRAPassengerTypeService {

	public passengerTypeRules: INDRAPaxTypeBusinessRules;

	constructor(private api: INDRAApiService, private http: HttpClient) {
}

	getAvailablePassengerTypes(params: INDRABFMAvailablePassengerTypeRequestParam): Observable<INDRABFMAvailablePassengerTypeResponse> {
		if (MOCK_STATUS.PASSENGER_TYPE) {
			return this.getMockData(params);
		} else {
			return this.api.INDRA_get<INDRABFMAvailablePassengerTypeResponse>(`${URL_AVAILABLE_PASSENGER_TYPES}market=${params.market}&journeyList${params.journeyList}&tripType=${params.tripType}`);
		}
	}

	getMockPassengerTypes(params: INDRABFMAvailablePassengerTypeRequestParam): Observable<INDRABFMAvailablePassengerTypeResponse> {
		return this.getMockData(params);
	}

	getMockData(params: INDRABFMAvailablePassengerTypeRequestParam) {
		if (params.isUnitedKingdomMarket) {
			return this.http.get<INDRABFMAvailablePassengerTypeResponse>(MOCK_URL_AVAILABLE_PASSENGER_TYPE_UK_MARKET);
		} else {
			return this.http.get<INDRABFMAvailablePassengerTypeResponse>(MOCK_URL_AVAILABLE_PASSENGER_TYPE);
		}
	}

	// for calendar, if only young adult passenger type (YTH) else (ADT)
	getPassengerCodeByCount(passengers) {
		let codeWithCount = 0;
		Object.values(passengers).forEach(count => {
			if (+count > 0) codeWithCount++;
		});

		return codeWithCount === 1 && passengers[PAX_TYPE_YOUNG_ADULT] > 0 ? PAX_TYPE_YOUNG_ADULT_CODE : PAX_TYPE_ADULT_CODE;
	}
}
